module.exports = __webpack_public_path__ + "static/media/03_05_07.08dcb1ee.png";